<div class="flex items-center justify-center h-full md:h-auto h-calc-content">
  <div
    class="bg-white rounded-lg w-full h-full md:h-auto md:w-[500px] p-6 md:relative"
  >
    <div>
      <!-- Título -->
      <h2 class="headline-05 text-[#003746] mb-2">Confirma tu código</h2>

      <!-- Subtítulo -->
      <div class="mb-4">
        <p class="paragraph-default text-[#303638]">
          Enviámos un código de seguridad de 6 dígitos al correo {{ correo }}
        </p>
      </div>

      <!-- Campo: Código de verificación -->
      <mat-form-field appearance="fill" class="w-full mb-4 custom-input">
        <mat-label>Ingresa el código</mat-label>
        <input matInput [formControl]="codigo" />
        <mat-error *ngIf="codigo?.hasError('required')"
          >Campo obligatorio</mat-error
        >
      </mat-form-field>
    </div>

    <p *ngIf="errorMensaje" class="text-[#BA1A1A] mb-2">{{ errorMensaje }}</p>

    <p class="text-[var(--login-p,#3D4E5F)] text-center m-2">Los campos con * son obligatorios.</p>

    <button
      class="w-full rounded-full bg-[#052631] text-white py-3"
      [disabled]="codigo.invalid"
      (click)="onSubmit()"
    >
      Siguiente
    </button>

    <div class="text-center m-1">
      <button
    class="text-sm text-[#FF1B44] font-semibold underline cursor-pointer bg-transparent border-none pt-3"
    (click)="resendCode()"
    >
    Enviar de nuevo
  </button>
    </div>
  </div>
</div>
